import { IBaseParams } from '@interfaces/IBaseParam';
import { IBaseResponse } from '@interfaces/IBaseResponse';
import { useMutation, useQuery } from 'react-query';
import {
  createQtyAdjusmentFromAPI,
  exportInventoryBinFromAPI,
  exportInventoryFromAPI,
  getInventoryReportFromAPI,
  getListBinByProduct,
  getListHistoryQtyAdjusmentFromAPI,
  getReportInventoryFromAPI,
  getStockAlertFromAPI,
  getStocksHistoryFromAPI,
  getStocksInventoryByBinFromAPI,
  getStocksInventoryFromAPI,
  importAdjustmentFromAPI,
  processQtyAdjusmentFromAPI,
  refreshRemainingStockFromAPI,
  setStockAlertFromAPI,
  transferStockBinFromAPI,
} from './inventory.api';
import {
  IHistoryQtyAdjutment,
  IInventoryReport,
  IParamCreateQtyAdjustment,
  IParamGetBinProduct,
  IParamProcessQtyAdjustment,
  IParamRefreshRemainingStock,
  IParamSetStockAlert,
  IParamsTFStockBin,
  IReportInventory,
  IStockAlert,
  IStockHistory,
  IStockInventory,
  IStockInventoryByBin,
} from './inventory.types';

export const actionGetStockInventory = (params: IBaseParams) =>
  useQuery(
    ['actionGetStockInventory', params],
    () => getStocksInventoryFromAPI(params),
    {
      select: (res) => (res?.data as IBaseResponse<IStockInventory[]>) ?? null,
    },
  );

export const actionGetStockInventoryByBin = (params: IBaseParams) =>
  useQuery(
    ['actionGetStockInventoryByBin', params],
    () => getStocksInventoryByBinFromAPI(params),
    {
      select: (res) =>
        (res?.data as IBaseResponse<IStockInventoryByBin[]>) ?? null,
    },
  );

export const actionGetStockHistory = (params: IBaseParams) =>
  useQuery(
    ['actionGetStockHistory', params],
    () => getStocksHistoryFromAPI(params),
    {
      select: (res) => (res?.data as IBaseResponse<IStockHistory[]>) ?? null,
    },
  );

export const actionTFStockBin = () =>
  useMutation((params: IParamsTFStockBin) => transferStockBinFromAPI(params));

export const actionGetHistoryQtyAdjusment = (params: IBaseParams) =>
  useQuery(
    ['actionGetHistoryQtyAdjusment', params],
    () => getListHistoryQtyAdjusmentFromAPI(params),
    {
      select: (res) =>
        (res?.data as IBaseResponse<IHistoryQtyAdjutment[]>) ?? null,
    },
  );

export const actionCreateQtyAdjustment = () =>
  useMutation((params: IParamCreateQtyAdjustment) =>
    createQtyAdjusmentFromAPI(params),
  );

export const actionGetListBinProduct = () =>
  useMutation((params: IParamGetBinProduct) => getListBinByProduct(params));

export const actionGetInventoryReport = () =>
  useQuery(['actionGetInventoryReport'], () => getInventoryReportFromAPI(), {
    select: (res) => (res?.data?.data as IInventoryReport) ?? null,
  });

export const actionExportInventory = (params: IBaseParams) =>
  useMutation(() => exportInventoryFromAPI(params));

export const actionGetStockAlert = (
  params: IBaseParams,
  isEnabled: boolean = false,
) =>
  useQuery(
    ['actionGetStockAlert', params],
    () => getStockAlertFromAPI(params),
    {
      select: (res) => (res?.data as IBaseResponse<IStockAlert[]>) ?? null,
      enabled: isEnabled,
    },
  );

export const actionSetStoclAlert = () =>
  useMutation((params: IParamSetStockAlert) => setStockAlertFromAPI(params));

export const actionGetReportInventory = (params: IBaseParams) =>
  useQuery(
    ['actionGetReportInventory', params],
    () => getReportInventoryFromAPI(params),
    {
      select: (res) => (res?.data as IBaseResponse<IReportInventory[]>) ?? null,
      enabled: !!params?.warehouse_id,
    },
  );

export const actionImportAdjutment = () =>
  useMutation((params: FormData) => importAdjustmentFromAPI(params));

export const actionProcessQtyAdjustment = () =>
  useMutation((params: IParamProcessQtyAdjustment) =>
    processQtyAdjusmentFromAPI(params),
  );

export const actionRefreshRemainingStock = () =>
  useMutation((params: IParamRefreshRemainingStock) =>
    refreshRemainingStockFromAPI(params),
  );

export const actionExportInventoryBin = (params: IBaseParams) =>
  useMutation(() => exportInventoryBinFromAPI(params));
